(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moksh-header"]) return;
  try {
    
document.addEventListener('click',event=>{const button=event.target.closest('[data-md-marquee-toggle]');if(!button)return;const bar=button.closest('[data-md-marquee]');const paused=bar.toggleAttribute('data-paused');button.setAttribute('aria-pressed',String(paused));button.querySelector('span').textContent=paused?'▶':'Ⅱ';});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moksh-shop"] && !Shopify.designMode) return;
  try {
    
const mokshShopCardOrder=new WeakMap();
document.addEventListener('click',event=>{const button=event.target.closest('[data-ms-filter]');if(!button)return;const root=button.closest('.ms-shop'),grid=root.querySelector('.ms-grid'),filter=button.dataset.msFilter;if(!mokshShopCardOrder.has(root))mokshShopCardOrder.set(root,Array.from(grid.querySelectorAll('.mc-card')));const cards=mokshShopCardOrder.get(root);root.querySelectorAll('[data-ms-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));const matches=card=>filter==='all'||card.dataset.category===filter||card.dataset.deity===filter;let ordered=cards;if(filter==='rudraksha'){const visible=cards.filter(matches),malas=visible.filter(card=>card.dataset.rudrakshaForm==='mala'),singles=visible.filter(card=>card.dataset.rudrakshaForm!=='mala');ordered=[];while(malas.length||singles.length){ordered.push(...malas.splice(0,2));if(singles.length)ordered.push(singles.shift());}ordered.push(...cards.filter(card=>!matches(card)));}ordered.forEach(card=>grid.appendChild(card));let count=0;cards.forEach(card=>{const match=matches(card);card.hidden=!match;if(match)count++;});root.querySelector('[data-ms-count]').textContent=count;root.querySelector('[data-ms-empty]').hidden=count!==0;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moksh-support"]) return;
  try {
    
document.addEventListener('toggle', function(event) {
  const opened = event.target;
  if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;
  const group = opened.closest('[data-md-faq]');
  if (!group) return;
  group.querySelectorAll('details[open]').forEach(function(detail) {
    if (detail !== opened && detail.closest('[data-md-faq]') === group) detail.open = false;
  });
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moksh-trishul-product"]) return;
  try {
    
document.addEventListener('click',event=>{const thumb=event.target.closest('[data-mdp-image]');if(thumb){const root=thumb.closest('.mdp');const hero=root.querySelector('.mdp-hero-image');hero.srcset='';hero.src=thumb.dataset.mdpImage;root.querySelectorAll('[data-mdp-image]').forEach(b=>b.setAttribute('aria-pressed',String(b===thumb)));}const zoom=event.target.closest('[data-mdp-zoom]');if(zoom){const root=zoom.closest('.mdp'),dialog=root.querySelector('.mdp-zoom');dialog.querySelector('img').src=root.querySelector('.mdp-hero-image').src;dialog.showModal();}const close=event.target.closest('[data-mdp-close]');if(close)close.closest('dialog').close();});

  } catch(e) { console.error(e); }
})();
})();
